import './js/base';
import './js/header';
import './layouts/plp/layout';

import './modules/existing/careers-application/module';
import './modules/custom/sds/module';
import './modules/custom/sds-updated/module';
import './modules/custom/hero-static/module';
import './modules/custom/hero-splide/module';
import './modules/custom/cat-cards/module';
import './modules/custom/service-cards/module';
import './modules/custom/custom-banner/module';
import './modules/custom/advantages-cards/module';
import './modules/custom/career-opportunities/module';
import './modules/custom/careers-application-updated/module';
import './modules/custom/section-title/module';
import './modules/custom/testimonials/module';
import './modules/custom/industry-boxes/module';
import './modules/custom/banner-grid/module';
import './modules/custom/top-brands/module';
import './modules/custom/gas-cards/module';
import './modules/custom/video-banner/module';
import './modules/custom/locations-map/module';
import './modules/custom/timeline/module';
import './modules/custom/contact-us-form/module';
import './modules/custom/content-page-card/module';
